// extracted by mini-css-extract-plugin
module.exports = {"deliveryProvider":"DeliveryProviderLabel__deliveryProvider___1dvOJ"};